import styled from "styled-components"

export default {
    "WrapperDiv": styled.main`
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        padding-top: 80px;
    `,
    "Title": styled.h1`
        ${({ theme }) => theme.font["xxlarge-bold"]};
    `,
    "Content": styled.p`
        ${({ theme }) => theme.font["medium-regular"]};
    `,
    "CautionSvg": styled.img`
        width: 80%;
        max-width: 400px;
    `
}